import { Link } from 'react-router-dom';

export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-landscape-line',
      title: 'Landscape Design',
      description: 'Custom outdoor living designs that transform your property into a functional and beautiful extension of your home',
      link: '/landscape-design',
      image: 'https://public.readdy.ai/ai/img_res/c1c787f7d6c58af3ff8c88081b5fe60e.jpg'
    },
    {
      icon: 'ri-building-line',
      title: 'Patios & Hardscaping',
      description: 'Premium paver patios, outdoor kitchens, fire pits, and custom hardscape installations for elevated outdoor living',
      link: '/patios-hardscaping',
      image: 'https://readdy.ai/api/search-image?query=luxury%20stone%20paver%20patio%20with%20outdoor%20kitchen%20and%20seating%20area%20in%20upscale%20backyard%20with%20simple%20clean%20background%20professional%20craftsmanship%20photography&width=600&height=400&seq=svc002&orientation=landscape'
    },
    {
      icon: 'ri-stack-line',
      title: 'Retaining Walls',
      description: 'Engineered retaining wall systems that solve drainage issues while creating stunning terraced landscapes',
      link: '/retaining-walls',
      image: 'https://readdy.ai/api/search-image?query=elegant%20stone%20retaining%20wall%20with%20terraced%20landscaping%20in%20residential%20property%20with%20simple%20clean%20background%20professional%20masonry%20photography&width=600&height=400&seq=svc003&orientation=landscape'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Landscape Lighting',
      description: 'Professional outdoor lighting design that enhances safety, security, and nighttime ambiance of your property',
      link: '/landscape-lighting',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20landscape%20lighting%20illuminating%20pathway%20plants%20and%20outdoor%20living%20space%20at%20night%20with%20simple%20clean%20background%20professional%20lighting%20photography&width=600&height=400&seq=svc004&orientation=landscape'
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Drainage Solutions',
      description: 'Expert drainage systems including French drains, dry creek beds, and grading to protect your landscape investment',
      link: '/drainage-solutions',
      image: 'https://readdy.ai/api/search-image?query=decorative%20dry%20creek%20bed%20drainage%20solution%20with%20river%20rocks%20and%20landscape%20design%20with%20simple%20clean%20background%20professional%20landscaping%20photography&width=600&height=400&seq=svc005&orientation=landscape'
    },
    {
      icon: 'ri-plant-line',
      title: 'Lawn Maintenance',
      description: 'Comprehensive lawn care and landscape maintenance to keep your outdoor spaces pristine year-round',
      link: '/lawn-maintenance',
      image: 'https://readdy.ai/api/search-image?query=pristine%20manicured%20lawn%20with%20professional%20landscape%20maintenance%20in%20upscale%20residential%20property%20with%20simple%20clean%20background%20professional%20lawn%20care%20photography&width=600&height=400&seq=svc006&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-[#E67E22] text-sm font-semibold tracking-wider uppercase mb-3">Our Expertise</div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Outdoor Living & Landscaping Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Specializing in custom patios, outdoor living spaces, retaining walls, landscape lighting, and drainage systems for Delaware County homeowners
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Link 
              key={index} 
              to={service.link}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center bg-[#E67E22] rounded-xl">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#E67E22] transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">{service.description}</p>
                <div className="flex items-center gap-2 text-[#E67E22] font-semibold whitespace-nowrap">
                  Learn More <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}